import { version } from '../package.json.js';
import { log } from '../logger/logger.js';
import { CMP } from './cmp.js';
import { disable, enable, isDisabled } from './disable.js';
import { getConsentFor as getConsentFor$2 } from './getConsentFor.js';
import { getFramework } from './getFramework.js';
import { onConsent as onConsent$2 } from './onConsent.js';
import { onConsentChange as onConsentChange$2 } from './onConsentChange.js';
import { isServerSide, cmp as cmp$1, onConsent as onConsent$1, onConsentChange as onConsentChange$1, getConsentFor as getConsentFor$1 } from './server.js';
import { initVendorDataManager } from './vendorDataManager.js';
var _a, _b, _c, _d;
if (!isServerSide) {
    if (typeof window.guCmpHotFix === "undefined") {
        window.guCmpHotFix = {};
    }
}
let _willShowPrivacyMessage;
let initComplete = false;
let resolveInitialised;
const initialised = new Promise((resolve) => {
    resolveInitialised = resolve;
});
const init = ({ pubData, country, isUserSignedIn = false, useNonAdvertisedList = false }) => {
    if (isDisabled() || isServerSide) {
        return;
    }
    if (window.guCmpHotFix.initialised) {
        if (window.guCmpHotFix.cmp?.version !== version) {
            console.warn("Two different versions of the CMP are running:", [
                version,
                window.guCmpHotFix.cmp?.version
            ]);
        }
        return;
    }
    window.guCmpHotFix.initialised = true;
    if (typeof country === "undefined") {
        throw new Error("CMP initialised without `country` property. A 2-letter, ISO ISO_3166-1 country code is required.");
    }
    const framework = getFramework(country);
    CMP.init(framework, country, isUserSignedIn, useNonAdvertisedList, pubData ?? {});
    void CMP.willShowPrivacyMessage().then((willShowValue) => {
        _willShowPrivacyMessage = willShowValue;
        initComplete = true;
        log("cmp", "initComplete");
    });
    resolveInitialised();
    initVendorDataManager();
};
const willShowPrivacyMessage = () => initialised.then(() => CMP.willShowPrivacyMessage());
const willShowPrivacyMessageSync = () => {
    if (_willShowPrivacyMessage !== void 0) {
        return _willShowPrivacyMessage;
    }
    throw new Error("CMP has not been initialised. Use the async willShowPrivacyMessage() instead.");
};
const hasInitialised = () => initComplete;
const showPrivacyManager = () => {
    void initialised.then(CMP.showPrivacyManager);
};
const cmp = isServerSide ? cmp$1 : (_a = window.guCmpHotFix).cmp ?? (_a.cmp = {
    init,
    willShowPrivacyMessage,
    willShowPrivacyMessageSync,
    hasInitialised,
    showPrivacyManager,
    version,
    // special helper methods for disabling CMP
    __isDisabled: isDisabled,
    __enable: enable,
    __disable: disable
});
const onConsent = isServerSide ? onConsent$1 : (_b = window.guCmpHotFix).onConsent ?? (_b.onConsent = onConsent$2);
const onConsentChange = isServerSide ? onConsentChange$1 : (_c = window.guCmpHotFix).onConsentChange ?? (_c.onConsentChange = onConsentChange$2);
const getConsentFor = isServerSide ? getConsentFor$1 : (_d = window.guCmpHotFix).getConsentFor ?? (_d.getConsentFor = getConsentFor$2);
export { cmp, getConsentFor, onConsent, onConsentChange };
